import React, { useEffect, useState } from 'react';
import moment from 'moment';
import cx from 'classnames';
import { Line } from 'react-chartjs-2';

import { useStyles } from './styles';
import bgBtn from '../../assets/images/button.png';
import bgBtnGray from '../../assets/images/button-gray.png';
import { Grid, Typography, CircularProgress, Button } from '@material-ui/core';
import { getDailyRevenue } from '../../api/stats';
import { numberWithCommas, periodsForDailyRevenueStats } from '../../utils/utils';

export default function DailyRevenue() {
  const classes = useStyles({ bgBtn, bgBtnGray });
  const [chartData, setChartData] = useState();
  const [loading, setLoading] = useState(false);
  const [period, setPeriod] = useState('thisWeek');
  const [startDate, setStartDate] = useState(moment().startOf('week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const count = ctx.dataset.count[ctx.dataIndex];
            return [`Revenue: $${ctx.formattedValue}`, `Number of Campaigns: ${count}`];
          },
        },
      },
      datalabels: {
        color: '#fff',
        anchor: 'end',
        align: 'top',
        clamp: true,
        formatter: function (value) {
          return `$${numberWithCommas(value)}`;
        },
      },
      legend: {
        display: true,
        labels: {
          color: 'white',
        },
      },
    },
    scales: {
      y: {
        grid: {
          borderColor: '#515151',
          tickColor: '#515151',
          color: '#515151',
        },
        ticks: {
          color: '#fff',
          callback: function (value) {
            return `$${numberWithCommas(value)}`;
          },
        },
        title: {
          align: 'end',
          display: true,
          text: 'Revenue, $',
          color: '#fff',
        },
      },
      x: {
        grid: {
          borderColor: '#515151',
          tickColor: '#515151',
          color: '#515151',
        },
        ticks: {
          color: '#fff',
          padding: 10,
        },
        title: {
          align: 'end',
          display: true,
          color: '#fff',
          text: 'Date',
        },
      },
    },
  };

  useEffect(() => {
    setLoading(true);
    setChartData();
    getDailyRevenue({ startDate, endDate }).then((result) => {
      setChartData(result);
      setLoading(false);
    });
  }, [period]);

  const setDateInterval = ({ start, end, value }) => {
    setStartDate(() => start);
    setEndDate(() => end);
    setPeriod(() => value);
  };

  return (
    <div className={`main container ${classes.container}`}>
      <Grid
        container
        direction="row"
        item
        md={12}
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography className={classes.title}>Daily chart of campaigns and revenue</Typography>
        <Grid
          container
          direction="row"
          style={{ marginTop: 15 }}
          item
          md={12}
          justifyContent="space-between"
          alignItems="center"
        >
          {periodsForDailyRevenueStats.map((item, i) => {
            const active = period === item.value;
            return (
              <Grid
                container
                key={i}
                direction="row"
                item
                md={3}
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  className={cx(classes.periodBtn, { active })}
                  type="button"
                  onClick={() => setDateInterval({ ...item.getTimeInterval(), value: item.value })}
                >
                  {item.label}
                </Button>
              </Grid>
            );
          })}
        </Grid>
        <Grid
          container
          direction="row"
          style={{ marginTop: 15 }}
          item
          md={12}
          justifyContent="center"
          alignItems="center"
        >
          {loading || !chartData ? (
            <CircularProgress />
          ) : (
            <Line data={chartData} options={options} />
          )}
        </Grid>
      </Grid>
    </div>
  );
}
